import { render, staticRenderFns } from "./SubFacilityDetail.vue?vue&type=template&id=089f411d&scoped=true"
import script from "./SubFacilityDetail.vue?vue&type=script&lang=js"
export * from "./SubFacilityDetail.vue?vue&type=script&lang=js"
import style0 from "./SubFacilityDetail.vue?vue&type=style&index=0&id=089f411d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f411d",
  null
  
)

export default component.exports